import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Modal,
  TextField,
  Button,
  IconButton,
  InputAdornment,

  Tooltip,
  Chip,
  CircularProgress,
} from "@mui/material";
import {
  Edit as EditIcon,
  Search as SearchIcon,
  WarningAmber as WarningIcon,
  CheckCircle as CheckIcon,
} from "@mui/icons-material";
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'; // icon for transfer

import axios from "axios";
import baseURL from "../../config";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import TransferVesselBeforeSignOnModal from "./TransferVesselBeforeSignOnModal";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

const COCmodal = ({ cocDetails }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCrewName, setSelectedCrewName] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [selectedContractId, setSelectedContractId] = useState(null);
  const [formData, setFormData] = useState({
    portName: "",
    portCountry: "",
    date: "",
    contractId: "",
    ImoCrewListFile: null,
    cdcStamppageFile: null,
  });

  const getRemainingDays = (dateStr) => {
    if (!dateStr) return null;
    const cocDate = new Date(dateStr);
    const today = new Date();
    const diffTime = today - cocDate;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const remaining = 30 - diffDays;
    return remaining > 0 ? remaining : 0;
  };

  const getContractRemainingDays = (startDateStr, durationInMonths) => {
    if (!startDateStr || !durationInMonths) return null;

    const startDate = new Date(startDateStr);
    const endDate = new Date(startDate);
    endDate.setMonth(endDate.getMonth() + parseInt(durationInMonths));

    const today = new Date();

    if (endDate <= today) return "Contract Ended";

    let remainingMonths = (endDate.getFullYear() - today.getFullYear()) * 12 +
      (endDate.getMonth() - today.getMonth());

    let adjustedEnd = new Date(today);
    adjustedEnd.setMonth(adjustedEnd.getMonth() + remainingMonths);

    // If adjustedEnd goes past the actual endDate, reduce a month
    if (adjustedEnd > endDate) {
      remainingMonths--;
      adjustedEnd.setMonth(adjustedEnd.getMonth() - 1);
    }

    // Now calculate the remaining days
    const remainingDays = Math.ceil((endDate - adjustedEnd) / (1000 * 60 * 60 * 24));

    const months = remainingMonths;
    const days = remainingDays;

    let result = [];
    if (months) result.push(`${months} month${months > 1 ? "s" : ""}`);
    if (days) result.push(`${days} day${days > 1 ? "s" : ""}`);

    return `Contract remaining : ${result.join(" ")} `;
  };

  const handleTransfer = (contractId) => {
    setSelectedContractId(contractId);
    setOpenModal(true);
  };


  const handleOpen = (contractId, crewName) => {
    setFormData({
      portName: "",
      portCountry: "",
      date: "",
      contractId,
      ImoCrewListFile: null,
      cdcStamppageFile: null,
    });
    setSelectedCrewName(crewName);
    setOpen(true);
  };

  const handleClose = () => {
    if (!loading) {
      setOpen(false);
    }
  };

  const handleChange = (e) =>
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files.length > 0) {
      setFormData((prev) => ({
        ...prev,
        [name]: files[0],
      }));
    }
  };

  const handleSave = async () => {
    const { portName, portCountry, date, contractId, cdcStamppageFile, ImoCrewListFile } = formData;

    if (!portName || !portCountry || !date || !cdcStamppageFile || !ImoCrewListFile) {
      toast.error("All fields are required.");
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const form = new FormData();

      const signOnData = [
        { portName, portCountry, date },
      ];

      form.append("contractId", contractId);
      form.append("signOn", JSON.stringify(signOnData));
      form.append("signOn[0][cdcStamppageFile]", cdcStamppageFile);
      form.append("signOn[0][ImoCrewListFile]", ImoCrewListFile);

      await axios.post(`${baseURL}/api/statusAfterForm1`, form, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("Data saved successfully, Please visit the sign-on page for further action.");
      handleClose();

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error("Error saving data:", error);
      toast.error("Failed to save data.");
    } finally {
      setLoading(false);
    }
  };

  const filteredCOCDetails = Array.isArray(cocDetails)
    ? cocDetails.filter((item) => {
      const vesselName = item.contractDetails?.ShipDetails?.vesselname?.toLowerCase() || "";
      const crewName = item.contractDetails?.crewdetails?.name?.toLowerCase() || "";
      return (
        vesselName.includes(searchQuery.toLowerCase()) ||
        crewName.includes(searchQuery.toLowerCase())
      );
    })
    : [];

  //contract Remaning Days
  console.log("cocDetails", cocDetails);


  return (
    <Box mt={3} width="100%" p={2}>
      {/* Header */}
      <Box
        sx={{
          p: 1,
          bgcolor: "#C30B12",
          color: "white",
          display: "flex",
          alignItems: "center",
          position: "relative",
        }}
      >
        <TextField
          placeholder="Search by Vessel or Crew Name"
          variant="outlined"
          size="small"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="primary" />
              </InputAdornment>
            ),
          }}
          sx={{
            bgcolor: "#f5f5f5",
            borderRadius: 2,
            width: 280,
          }}
        />
        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            whiteSpace: "nowrap",
          }}
        >
          COC Details
        </Typography>
      </Box>

      {/* Table */}
      <Paper elevation={3} sx={{ p: 2 }}>
        {filteredCOCDetails.length > 0 ? (
          <Table stickyHeader>
            <TableHead>
              <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                <TableCell sx={{ fontWeight: "bold", width: "100px" }}>Sr. No.</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Contract Details</TableCell>
                <TableCell sx={{ fontWeight: "bold", width: "250px" }}>Transfer Details</TableCell>
                <TableCell sx={{ fontWeight: "bold" }} align="center">
                  Action
                </TableCell>

              </TableRow>
            </TableHead>
            <TableBody>
              {filteredCOCDetails.map((item, index) => {
                const cocDate = item.contractStatusAfterForm1?.coc?.[0]?.Date || item.contractStatusAfterForm1?.coc?.[0]?.date;
                const remainingDays = getRemainingDays(cocDate);
                const duration = item.contractDetails?.contractDuration;
                const contractRemainingLabel = getContractRemainingDays(cocDate, duration);
                const secondCocDate = item?.contractStatusAfterForm1?.coc?.[1]?.Date;

                return (
                  <TableRow key={index} hover>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      <Box display="flex" flexDirection="row" gap={4} mb={1}>
                        <Typography variant="subtitle2" fontWeight="bold">
                          <strong style={{ color: "black" }}>Vessel Name:</strong>{" "}
                          {item.contractDetails?.ShipDetails?.vesselname || "N/A"}
                        </Typography>


                      </Box>
                      {console.log("coc", item)}
                      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                        <Chip size="small" label={`Crew: ${item.contractDetails?.crewdetails?.name || "N/A"}`} sx={{ bgcolor: "#e3f2fd", color: "#0d47a1" }} />
                        <Chip size="small" label={`Indos No.: ${item.contractDetails?.crewdetails?.indosno || "N/A"}`} sx={{ bgcolor: "#fff9c4", color: "#f57f17" }} />
                        <Chip size="small" label={`Agent: ${item.contractDetails?.crewingAgent?.agentName || "N/A"}`} sx={{ bgcolor: "#e8f5e9", color: "#1b5e20" }} />
                        <Chip
                          size="small"
                          label={`COC Date: ${cocDate ? new Date(cocDate).toLocaleDateString("en-GB") : "N/A"}`}
                          sx={{ bgcolor: "#fff3e0", color: "#e65100", fontWeight: 'bold' }}
                        />
                        {remainingDays !== null && (
                          <Chip
                            size="medium"
                            icon={
                              remainingDays === 0 ? (
                                <WarningIcon sx={{ color: "#b71c1c" }} />
                              ) : (
                                <HourglassEmptyIcon sx={{ color: "#1b5e20" }} />
                              )
                            }
                            label={
                              remainingDays === 0
                                ? "COC Expired"
                                : `SignOn Remaining: ${remainingDays} day${remainingDays > 1 ? "s" : ""}`
                            }
                            sx={{
                              bgcolor: remainingDays === 0 ? "#ffebee" : "#ede7f6",
                              color: remainingDays === 0 ? "#b71c1c" : "#311b92",
                              fontWeight: "bold",
                              borderRadius: 2,
                              px: 2,
                              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                              userSelect: "none",
                              minWidth: 130,
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          />
                        )}
                        {contractRemainingLabel && (
                          <Chip
                            size="medium"
                            icon={
                              contractRemainingLabel === "Contract Ended" ? (
                                <WarningIcon sx={{ color: "#b71c1c" }} />
                              ) : (
                                <HourglassEmptyIcon sx={{ color: "#0277bd" }} />
                              )
                            }
                            label={contractRemainingLabel}
                            sx={{
                              bgcolor: contractRemainingLabel === "Contract Ended" ? "#ffebee" : "#e1f5fe",
                              color: contractRemainingLabel === "Contract Ended" ? "#b71c1c" : "#01579b",
                              fontWeight: "bold",
                              borderRadius: 2,
                              px: 2,
                              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                              userSelect: "none",
                              minWidth: 180,
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          />
                        )}

                      </Box>
                    </TableCell>
                    <TableCell>
                      {item.contractDetails?.transferedVesselName && (
                        <Typography variant="subtitle2" fontWeight="bold">
                          <strong style={{ color: "black" }}>Vessel Name:</strong>{" "}
                          {item.contractDetails.transferedVesselName}
                        </Typography>
                      )}

                      {secondCocDate && (
                        <Typography variant="body2" fontWeight="bold" style={{ color: "black" }}>
                          <strong>COC Date:</strong>&nbsp;
                          {new Date(secondCocDate).toLocaleDateString()}
                        </Typography>
                      )}


                      {item?.contractStatus?.Form1FOrRejectedCoc?.originalName && (
                        <Typography variant="body2" fontWeight="bold" display="flex" alignItems="center" gap={1}>
                          Form I:
                          <Tooltip title="View PDF" arrow>
                            <a
                              href={`${baseURL}/Documents/vesselupload/${item.contractStatus.Form1FOrRejectedCoc.fileName}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <PictureAsPdfIcon style={{ color: 'red', cursor: 'pointer' }} />
                            </a>
                          </Tooltip>
                        </Typography>
                      )}


                    </TableCell>
                    <TableCell align="center">
                      <Tooltip title="Add Signon">
                        <IconButton
                          onClick={() =>
                            handleOpen(
                              item.contractDetails?._id || "",
                              item.contractDetails?.crewdetails?.name || "N/A"
                            )
                          }
                          color="primary"
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Transfer Vessel">
                        <IconButton
                          onClick={() => handleTransfer(item.contractDetails?._id)}
                          color="secondary"
                        >
                          <SwapHorizIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        ) : (
          <Typography color="textSecondary" align="center" sx={{ mt: 2 }}>
            No matching COC details found.
          </Typography>
        )}
      </Paper>

      {/* Modal */}
      <Modal open={open} onClose={handleClose}>
        <Paper
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 450,
            p: 4,
            borderRadius: 3,
            boxShadow: 24,
          }}
        >
          <Typography variant="h6" align="center" gutterBottom>
            Enter Sign-On: {" "}
            {selectedCrewName && (
              <span style={{ color: "green" }}> {selectedCrewName}</span>
            )}
          </Typography>

          <TextField
            required
            fullWidth
            label="Port Name"
            name="portName"
            value={formData.portName}
            onChange={handleChange}
            margin="normal"
            variant="outlined"
          />

          <TextField
            required
            fullWidth
            label="Port Country"
            name="portCountry"
            value={formData.portCountry}
            onChange={handleChange}
            margin="normal"
            variant="outlined"
          />

          <TextField
            required
            fullWidth
            label="Date"
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            margin="normal"
            variant="outlined"
            inputProps={{ max: new Date().toISOString().split("T")[0] }}
          />

          <Box mt={2}>
            <Typography variant="body2" gutterBottom>
              CDC Stamp Page File *
            </Typography>
            <label htmlFor="cdc-upload">
              <input
                accept="application/pdf,image/*"
                style={{ display: "none" }}
                id="cdc-upload"
                type="file"
                name="cdcStamppageFile"
                onChange={handleFileChange}
              />
              <Button variant="outlined" component="span" fullWidth>
                {formData.cdcStamppageFile?.name || "Upload File"}
              </Button>
            </label>
          </Box>

          <Box mt={2}>
            <Typography variant="body2" gutterBottom>
              IMO Crew List File *
            </Typography>
            <label htmlFor="imo-upload">
              <input
                accept="application/pdf,image/*"
                style={{ display: "none" }}
                id="imo-upload"
                type="file"
                name="ImoCrewListFile"
                onChange={handleFileChange}
              />
              <Button variant="outlined" component="span" fullWidth>
                {formData.ImoCrewListFile?.name || "Upload File"}
              </Button>
            </label>
          </Box>

          <Box mt={3} display="flex" justifyContent="space-between">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSave}
              disabled={loading}
              startIcon={loading && <CircularProgress size={20} color="inherit" />}
            >
              {loading ? "Saving..." : "Save"}
            </Button>
            <Button variant="outlined" color="secondary" onClick={handleClose} disabled={loading}>
              Cancel
            </Button>
          </Box>
        </Paper>
      </Modal>

      <TransferVesselBeforeSignOnModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        contractId={selectedContractId}
      />

      <ToastContainer />
    </Box>
  );
};

export default COCmodal;
